import { LIGHT_PRODUCT_LIST_FIELDS } from './fragments/productFields';

const getFilteredProductsFromCollectionPagination = (
    categoryHandle,
    categoryId,
    filters,
    afterCursor,
    country
) => `${country ? `query @inContext(country: ${country})` : ''} {
  collection(handle: "${categoryHandle}") {
    handle
    products(first: 24 after: "${afterCursor}",
      filters: { productMetafield: { namespace: "${filters.namespace}", key: "${filters.key}", value: "${
          filters.value
      }" } }
    ) {
      edges {
        node {
          ${LIGHT_PRODUCT_LIST_FIELDS({
              variantFirst: 2,
              imageCount: categoryHandle === 'all-torsos-new-website' || categoryId === 'bodies' ? 50 : 4,
          })}
        }
        cursor
      }
      pageInfo { hasNextPage }
    }
  }
}`;

export default getFilteredProductsFromCollectionPagination;
